import { useCallback, useEffect, useState } from 'react'

import { InvoiceTimelineResponse } from '../types/invoiceTimeline'
import { fetchInvoiceTimeline } from './invoiceTimelineService'

/**
 * SC-10890.
 *
 * `enabled` existe para o fetch só acontecer quando o accordion é expandido: sem
 * isso, todo detalhe de cobrança aberto no sistema dispararia uma busca de
 * timeline — e são 479 mil cobranças já abertas na base.
 *
 * Estado local, não na query string (diferente do useActivityFeed): isto vive
 * dentro de um modal, e mexer na URL da página de cobranças ao expandir uma seção
 * seria efeito colateral.
 */
const useInvoiceTimeline = (billingUuid?: string, enabled = true) => {
  const [data, setData] = useState<InvoiceTimelineResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    if (!billingUuid || !enabled) return

    setLoading(true)
    setError(null)

    const response = await fetchInvoiceTimeline(billingUuid)
    if (!response) {
      setError('Não foi possível carregar o histórico da cobrança.')
    } else {
      setData(response)
    }

    setLoading(false)
  }, [billingUuid, enabled])

  useEffect(() => {
    load()
  }, [load])

  return { data, loading, error, reload: load }
}

export default useInvoiceTimeline
